import { render, staticRenderFns } from "./UsersTodoList.vue?vue&type=template&id=412241c9&scoped=true&"
import script from "./UsersTodoList.vue?vue&type=script&lang=js&"
export * from "./UsersTodoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412241c9",
  null
  
)

export default component.exports